<template>
<div>

  <CContainer :fluid="true">
        <h1 class="fw-200">Alta de Solicitud</h1>       
            <br>
            <CRow>
                <CCol>
                    <h2 class="fw-200">Productos</h2>
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12" class='px-0'>
                    <CListGroup >
                        <CListGroupItem>
                            <CForm @submit.prevent="addItem" ref="item_form">
                            <CRow class="d-flex gx-2">
                                <CCol  md="4">
                                    <CInput 
                                        ref='name'
                                        :disabled='editableItem !== ""' 
                                        v-bind.sync="item_form_errors.name" 
                                        placeholder='Nombre del producto' 
                                        v-model='item_form.name' 
                                        @input='clearItemFormError("name")'
                                        label='Nombre del producto'/>

                                </CCol>
                                <CCol md="2">
                                    <CInput 
                                        ref='quantity'
                                        :disabled='editableItem !== ""'  
                                        v-bind.sync="item_form_errors.quantity"  
                                        placeholder='Cantidad' 
                                        v-model="item_form.quantity" 
                                        @input='updateSubtotal("quantity")' 
                                        label='Cantidad'/>
                                </CCol>
                                <CCol md="2">
                                    <CInput 
                                        id='price'
                                        ref='price' 
                                        :disabled='editableItem !== ""' 
                                        v-bind.sync="item_form_errors.price" 
                                        lang='es' 
                                        placeholder='Precio por unidad' 
                                        v-model="item_form.price" 
                                        @input="updateSubtotal('price')" 
                                        label='Precio por unidad'>
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                </CCol>
                                <CCol  md="2">
                                    <CInput 
                                        disabled 
                                        :value='subtotalWithCommas'
                                        placeholder='Subtotal' 
                                        
                                        label='Subtotal'>
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                </CCol>
                                <CCol md='2' class=''>
                                    <CButton 
                                        class='item-form-button' 
                                        color='primary' 
                                        type='submit'>
                                        Agregar Item
                                    </CButton>
                                </CCol>
                            </CRow>
                            </CForm>
                        </CListGroupItem>
                        <CListGroupItem 
                        class='list-header'
                        color="dark"
                        >
                            <CRow class="d-flex">
                                
                                <CCol col="3" sm="4">
                                    <span class='d-none d-sm-block'>Nombre del Producto</span>
                                    <span class='d-sm-none'>N. del Producto</span>
                                </CCol>
                                <CCol col="3" sm="3">
                                    <span class='d-none d-sm-block'>Cantidad</span>
                                    <span class='d-sm-none'>Cant.</span>
                                </CCol>
                                <CCol col="3" sm="2">
                                    <span class='d-none d-sm-block'>Precio por unidad</span>
                                    <span class='d-sm-none'>Precio unitario</span>
                                </CCol>
                                <CCol col="3" sm="2">
                                    Subtotal
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                          <CListGroupItem 
                            class='item-list'
                            color="light"
                            >
                            <CRow class="d-flex item" v-for='(item, i) in form.description.items' :key='`item-${i}`'>
                                
                                <CCol col="3" sm="4" class='d-flex align-items-center editable-item-input'>

                                    <CInput v-if='editableItem === i'
                                        :ref='`name-${i}`' 
                                        class='flex-fill mb-sm-auto '
                                        v-bind.sync="editable_item_form_errors.name" 
                                        placeholder='Nombre del producto' 
                                        v-model='form.description.items[i].name' 
                                        @input='clearItemFormError("name")'/>

                                    <span class='text-truncate' v-else>
                                        {{item.name}}
                                        </span>
                                    
                                </CCol>

                                <CCol col="3" sm="3" class='d-flex align-items-center editable-item-input'>
                                    <CInput v-if='editableItem === i'
                                        :ref='`quantity-${i}`' 
                                        class='flex-fill mb-auto'
                                        v-bind.sync="editable_item_form_errors.quantity"  
                                        placeholder='Cantidad' 
                                        v-model="form.description.items[i].quantity" 
                                        @input='updateEditableItemSubtotal(i)'/>
                                    <span v-else>
                                        {{item.quantity}}
                                    </span>
                                    
                                </CCol>
                                <CCol col="2" sm="2" class='d-flex align-items-center editable-item-input'>
                                      <CInput v-if='editableItem === i'
                                        :ref='`price-${i}`'
                                        :id='`price-${i}`'  
                                        class='flex-fill mb-auto'
                                        v-bind.sync="editable_item_form_errors.price" 
                                        lang='es' 
                                        placeholder='Precio por unidad' 
                                        
                                        v-model="form.description.items[i].price" 
                                        @input="updateEditableItemSubtotal(i)" >
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                    <span v-else>
                                        {{getItemPrice(i)}}
                                    </span>
                                    
                                </CCol>
                                <CCol col="2" sm="2" class='d-flex align-items-center editable-item-input'>
                                    <CInput v-if='editableItem === i'
                                        disabled 
                                        class='flex-fill mb-auto'
                                        :id='`subtotal-${i}`'
                                        placeholder='Subtotal' 
                                        :value="editableItemSubtotalWithCommas">
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                    <span v-else>
                                         ${{form.description.items[i].subtotal.toString().replace('.', ',')}}
                                    </span>
                                   
                                </CCol>
                                <CCol col='12' sm='1' class='d-flex align-items-center mt-2 mt-sm-0' >
                                    <template v-if='editableItem === i'>
                                        <CButton v-c-tooltip='"Aceptar"' size='sm' color='primary' @click="updateItem(i)"><CIcon name='cil-check-alt' /></CButton>
                                    </template> 
                                    <template v-else>
                                        <CButton v-c-tooltip='"Modificar"' class='mr-1 ' size='sm' color='warning' @click='setEditableItem(i)'><CIcon name='cil-pencil' size='sm'/></CButton>
                                        <CButton v-c-tooltip='"Borrar"' size='sm' color='danger' @click="deleteItem(i)"><CIcon name='cil-x' size='sm'/></CButton>
                                    </template>
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                    </CListGroup>
                </CCol>
            </CRow>
             <br>
            <CRow>
                <CCol>
                    <h2>Datos de la solicitud</h2>
                </CCol>
                <CCol sm='12'>
                    <CListGroup>
                        <CListGroupItem>
                            <CForm @submit.prevent='submit' ref="order_form">
                            <CRow >
                                <CCol md='3' class='order-2 order-md-1'>
                                    <CSelect 
                                        ref="priority_id"
                                        :options='priorities' 
                                        label='Prioridad' 
                                        :value.sync='form.priority_id'
                                        v-bind.sync='errors.priority_id'
                                        @input='clearOrderFormError("priority_id")'/>
                                </CCol>
                                <CCol md='3' class='order-3 order-md-2'>
                                    <CSelect 
                                        ref='department_id'
                                        :options='departments' 
                                        label='Sector' 
                                        :value.sync='form.department_id'
                                        v-bind.sync="errors.department_id"
                                        @input='clearOrderFormError("department_id")'/>
                                </CCol> 
                                <CCol md='3' class='order-4 order-md-3'>
                                    <CSelect 
                                        ref="scheduled_order"
                                        :options='orderTypes' 
                                        label='Tipo de solicitud' 
                                        :value.sync='form.scheduled_order'
                                        v-bind.sync="errors.scheduled_order"
                                        @input='clearOrderFormError("scheduled_order")'/>
                                </CCol>
                                <CCol md='3' class='order-1 order-md-4'>
                                    <CInput 
                                        disabled 
                                        label='Total' 
                                        :value='totalWithCommas'>
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                        </CInput>
                                </CCol>
                                
                            </CRow>
                            <CRow>
                                <CCol md='6' class='order-2 order-md-1'>
                                    <CTextarea 
                                        v-bind.sync='errors["description.text"]'
                                        v-model="form.description.text" 
                                        placeholder='Mensaje (Opcional, max. 80 caracteres)'
                                        @input='clearOrderFormError("description.text")' 
                                        :value.sync='form.description.text'/>
                                </CCol>
                                <CCol md='3' class='order-1 order-md-2'>
                                    <CInput
                                        ref="days" 
                                        label='Cantidad de días' 
                                        type='number' 
                                        v-model="form.days" 
                                        v-if="form.scheduled_order"
                                        v-bind.sync="errors.days"
                                        
                                        @input='clearOrderFormError("days")'
                                        />
                                </CCol>
                                <CCol md='3' class='order-3 order-md-3 buttons-container'>
                                    <label for="" class='w-100'>Acciones</label>
                                    <CButton type='submit' color='success' class='mb-2 mb-sm-0 buttons'>
                                        Enviar solicitud
                                    </CButton>
                                    <CButton color='danger' class='ml-xl-4 buttons' @click="clearForm">
                                        Empezar de nuevo
                                    </CButton>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CInput
                                    type="hidden"
                                    ref="hidden"
                                    v-bind.sync="errors.hidden"
                                    v-model="order.hidden"
                                />
                            </CRow>

                            </CForm>
                        </CListGroupItem>
                    </CListGroup>
                </CCol>
            </CRow>

  </CContainer>
</div>
</template>

<script>
import axios from 'axios';
export default {
    data(){
        return {
            errors: {
                description: {}
            },
            item_form_errors: {},
            editable_item_form_errors: {},
            priorities: [],
            departments: [],
            item_form: {
                quantity: '',
                price: '',
                subtotal: ''
            },
            editableItem: '',
            order: {
                hidden: undefined
            },
            form: {
                description: {
                    items: [],
                    text: "",
                },
                scheduled_order: 0,
                priority_id: 1,
                department_id: 1,
                total: 0
            },
            orderTypes: [
                {value: 0, label: 'Normal'},
                {value: 1, label: 'Automática'}
            ],
        }
    },
    created(){
        this.getExternalData();
    },
    mounted(){
        let priceInput = document.getElementById('price');
        this.$utils.registerPriceInput([priceInput]);  
    },
    methods:{
        /**
         * Añadimos un item a la orden
         */
        addItem(){
            console.group('addItem')
            console.log('entrando a addItem', this.item_form.price);
            // Ver manipulación de string de precio
            const originalPrice = this.item_form.price + ''; // evitamos pass by reference
            // Hay que evitar el cambio de tipos lo mas posible. esto acá es NaN si no se le pasa precio. debería ser null.
            console.log('entrando a getFormattedPrice', this.item_form.price)
            this.item_form.price = this.$utils.getFormattedPrice(this.item_form.price) 
            console.log('saliendo de getFormattedPrice', this.item_form.price);
            // Ver manipulación de string de precio
            this.item_form_errors = {};
            let form = this.item_form;
            this.$api.item_form.store(form)
                .then(res => {
               
                    this.form.description.items.push(form);
                    this.clearItemForm();
                    this.updateTotal();
                    this.$refs.name.$el.children[1].focus()
                })
                .catch(error => {
                    if(error.response){
                        this.setItemFormErrorMessages(error.response.data.errors);
                    }
                    this.item_form.price = originalPrice;   
                });
            console.log('saliendo de addItem', this.item_form.price);
            console.groupEnd()
        },
        /**
         * Borramos un item de la orden
         * @param {number} index La posición del item
         */
        deleteItem(index){
            this.form.description.items.splice(index, 1);
            this.updateTotal();
        },
        /**
         * Actualizamos el subtotal de la orden, acepta como parametro un numero con el indice de un item
         * Si está presente, borra los errores del form de ese item.
         * @param {number} label   
         */
        updateSubtotal(label = null){
            console.group("updateSubtotal");
            if(label){
                this.clearItemFormError(label);
            }
            console.log("entrando a updateSubtotal", this.item_form.subtotal);
            console.log('entrando a getFormattedPrice', this.item_form.subtotal);

            let formattedItemPrice = this.$utils.getFormattedPrice(this.item_form.price);
            
            console.log('saliendo de getFormattedPrice', formattedItemPrice);
            // Calculamos el subtotal de este item
            let calc = (this.item_form.quantity * formattedItemPrice).toFixed(2);
            // Si el parseado de lo anterior es NaN, el subtotal es 0
            if (!isNaN(parseInt(calc))){
                this.item_form.subtotal = calc;
            } else {
                this.item_form.subtotal = 0;
            }
            console.log('saliendo de updateSubtotal', this.item_form.subtotal);
            console.groupEnd()
        },
        clearItemFormError(value){
            this.item_form_errors[value] = {};
        },
        clearItemForm(){
            let form = this.$refs.item_form;
            form.reset();
            this.item_form = {
                quantity: '',
                price: '',
                subtotal: ''
            }
        },
        clearOrderFormError(value){
            this.errors[value] = {}
        },
        clearForm(){
            let order_form = this.$refs.order_form;
            order_form.reset();
            this.updateTotal();
            this.clearItemForm();
            this.form = {
                description: {
                    items: [],
                    text: "",
                },
                scheduled_order: 0,
                priority_id: 1,
                department_id: 1,
                total: '0'
            }
        },
        getExternalData(){
            let me = this;
            let request_1 = me.$api.departments.index();
            let request_2 = me.$api.priorities.index();
            axios.all([request_1, request_2])
            .then(axios.spread((response_1, response_2) => {
                me.departments = [];
                me.departments = response_1.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.priorities = [];
                me.priorities = response_2.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });
            }))
            .catch(error => {
                console.log(error);
                console.log(error.response);
            });
        },
        updateTotal(){
            let total = 0;
               this.form.description.items.forEach(item => {
              
                let formattedPrice = this.$utils.getFormattedPrice(item.subtotal);
                total = parseFloat(total + formattedPrice) ;
            });
            this.form.total = total;
        },
        submit(){
            console.group('submit');
            console.log(this.form);
            console.groupEnd();
            let me = this;
            this.$api.orders.store(this.form)
             .then(response => {
                this.$swal.fire({
                    titleText: "¡Excelente!",
                    text: response.message ?? "Orden creada exitosamente",
                    icon: "success"
                });
                this.$router.push('/ordenes');
            })
            .catch(error => {
               console.log(error.response);
                
                if(error.response && error.response.status == 422){

                    me.setErrorMessages(error.response.data.errors);
                    if(error.response.data.errors["description.items"]){
                        this.$swal.fire({
                            titleText: "Algo salió mal",
                            text: error.response.data.errors["description.items"][0],
                            icon: "error"
                        })
                    }
                } else {
                    this.$swal.fire({
                    titleText: "Algo salió mal",
                    text: error.response.message ?? "Error al crear",
                    icon: "error"
                });
                }
            });
        },
        setErrorMessages(errors){
            let me = this;
            for (const item in errors) {
                me.errors[item] = {
                    invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                    isValid: false
                };
                this.$refs[item]
            }

            me.$refs["hidden"].$emit('input',(Math.random()*1e32).toString(36), new InputEvent(""));
        },
        setItemFormErrorMessages(errors, index = null){
            let me = this;
            if(typeof index == 'number'){
                for (const item in errors) {
                    me.editable_item_form_errors[item] = {
                        invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                        isValid: false
                    };
                    this.$refs[item]
                }
            } else {
                for (const item in errors) {
                    me.item_form_errors[item] = {
                        invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                        isValid: false
                    };
                    this.$refs[item]
                }
            }
            me.$refs["hidden"].$emit('input',(Math.random()*1e32).toString(36), new InputEvent(""));
        },
        setNumberWithCommas(value){
           return parseFloat(value).toFixed(2).toString().replace('.', ',');
        },
        /**
         * Hacemos editable un item
         * 
         * @param {number} index El índice del item para editar
         */
        setEditableItem(index){
            
            this.editableItem = index;
            if(typeof index === 'number'){
                setTimeout(() => {
                    let priceInput = document.getElementById(`price-${index}`);
                    let subtotalInput = document.getElementById(`subtotal-${index}`)
                    this.$utils.registerPriceInput([priceInput, subtotalInput]);
                    // Comprobamos que no sea null
                     let price = this.form.description.items[index].price
                    if(price !== null){
                        price = price.toString().replace('.',',');
                        this.form.description.items[index].price = this.$utils.completeWithZeros(price);
                    }
                }, 100)

            }

        },
        /**
         * Actualizamos el subtotal del item editable
         *  @todo Acá el subtotal entra como un string y se va como un string. Debería entrar y salir siendo un number
         */
        updateEditableItemSubtotal(index){
       
            //console.log('entrando a updateEditableItemSubtotal', this.form.description.items[index].subtotal);
            let formattedEditablePrice = this.$utils.getFormattedPrice(this.form.description.items[index].price + '');

            // Cambiar esto por un numero.
            let calc = (this.form.description.items[index].quantity * formattedEditablePrice).toFixed(2).toString().replace('.',',');
            if(!isNaN(parseInt(calc))){
                this.form.description.items[index].subtotal = calc;
            } else {
                this.form.description.items[index].subtotal = 0;
            }
            //console.log('saliendo de updateEditableItemSubtotal', this.form.description.items[index].subtotal)
           
        },
        updateItem(index){
            //console.group('updateItem')
            //console.log('entrando a updateItem', this.form.description.items[index].price)

            const originalPrice = this.form.description.items[index].price + ''; // evitamos pass by reference

           // console.log('entrando a getFormattedPrice', this.form.description.items[index].price)

            this.form.description.items[index].price = this.$utils.getFormattedPrice(originalPrice)

            //console.log('saliendo de getFormattedPrice', this.form.description.items[index].price)

            this.$api.item_form.store(this.form.description.items[index])
                .then(res => {
                   this.setEditableItem('');
                   this.editable_item_form_errors = {}; 

                   //console.log('entrando a completeWithZeros', this.form.description.items[index].price);
                    // Comprobamos que no sea null
                   if(this.form.description.items[index].price !== null){
                        this.form.description.items[index].price = this.$utils.completeWithZeros(originalPrice);
                   }

                   // console.log('saliendo de completeWithZeros', this.form.description.items[index].price)

                   this.updateEditableItemSubtotal(index)
                   this.updateTotal();
                })
                .catch(error => {
                 
                    if(error.response){
                        this.setItemFormErrorMessages(error.response.data.errors, index);
                    }
                    this.form.description.items[index].price = originalPrice;
                });

            //console.log('saliendo de updateItem', this.form.description.items[index].price)
            //console.groupEnd()
        },
        /**
         * Obtenemos el precio indicado si es que existe
         * @param {number} index El índice del array de productos
         * @returns {string} Un valor para mostrar. Puede ser el precio o un guión.
         */
        getItemPrice(index){
            let price = this.form.description.items[index].price;
            if(price !== null){
                return `$${this.$utils.completeWithZeros(price.toString().replace('.', ','))}`
            } else {
                return "N/A"
            }
            
            /*
            if(!isNaN(price) && typeof price === 'number'){
          
                return `$${this.$utils.completeWithZeros(price.toString().replace('.', ','))}`
            } else {
                return "N/A";
            }*/
        }

    },
    computed: {
        totalWithCommas(){
            return parseFloat(this.form.total).toFixed(2).toString().replace('.', ',');
        },
        subtotalWithCommas(){
            return this.item_form.subtotal.toString().replace('.', ',');
        },
        editableItemSubtotalWithCommas(){
            
            return this.form.description.items[this.editableItem].subtotal;
        },

    },
    
}
</script>

<style lang='scss'>
    .fw-200{
        font-weight: 200;
    }
    .btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    border-radius: 35px;
    font-size: 24px;
    line-height: 1.33;
}
.item-form-button{
    @media screen {
        margin-top: 1.75rem;
    }
}
.list-header{
    @media screen and (max-width: 768px){
        position: sticky;
        top: 0;
    }
}
.item{
    padding-top: 1rem;
    padding-bottom: 1rem;
    @media screen and (max-width: 768px){
        overflow: hidden;
    }
    &:nth-child(odd){
        background-color: white;
    }
}
.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
}
@media screen and (max-width: 480px) {
    .buttons{
        width: 100%;
    }
}
@media screen and (min-width: 481px) and (max-width: 766px){
    .buttons{
        width: 50%;
    }
}
@media screen and (min-width: 767px) and (max-width: 1610px) {
    .buttons-container{
      flex: 0 0 100%;
      max-width: 100%;  
    }
}

.editable-item-input{
    @media screen and (max-width: 667px){
        padding-left: 8px;
        padding-right: 8px;
    }
    .input-group-prepend{
        @media screen and (max-width: 667px){
            display: none;
        }
    }
}

.item-list{
    padding: 0;
    max-width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    @media screen and (max-width: 768px){
        overflow: hidden;
    }
}



</style>
<style lang="scss">
.tooltip-old{
    z-index: 9999;
}
</style>
